var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.id)?_c('span',{staticClass:"mediumName",style:(_vm.bottonStyle)},[_vm._v(_vm._s(_vm.mediumName))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }